import {createElement} from 'methods/utils';

function FormErrorsMixin() {
    this.fieldsErorrs = []
}

FormErrorsMixin.prototype.resetFieldsErrors = function(except = []) {
    this.fieldsErorrs = this.fieldsErorrs.filter(error => {
        if (except.includes(error.field)) {
            return true;
        }

        error.remove();
        return false;
    });
}

FormErrorsMixin.prototype.showFieldsErrors = function(fields) {
    for (let field in fields) {
        this.showFieldError(field, fields[field]);
    }
}

FormErrorsMixin.prototype.showFieldError = function(field, text) {
    const $input = this.$form.elements[field];
    if (typeof $input == 'undefined') {
        return;
    }

    $input.classList.add('is-error');

    let $error = $input.parentElement.querySelector('.js-error');
    if ($error) {
        $error.textContent = text;
        return;
    }

    $error = createElement(
        `<div class="${this.modal.className}__field-error ${this.className}__field-error js-error">${text}</div>`
    );

    $input.insertAdjacentElement('afterend', $error);
    $error.animate([
        {opacity: 0, marginTop: '0px'},
        {opacity: 1, marginTop: '4px'},
    ], 100);

    this.fieldsErorrs.push({
        field,
        $error,
        $input,
        remove: () => {
            $input.classList.remove('is-error');
            $error.remove();
        },
    });
}

export default FormErrorsMixin;
